import { rootApi } from '../rootApi';

export const translationApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        // Dynamic translation data endpoint - TranslationT tablosundan tüm veriyi çeker (no pagination)
        getTranslationData: builder.query({
            query: ({ LangId, TranslationIds, SearchText }) => ({
                url: 'v1/compound/GetTranslationData',
                method: 'GET',
                params: {
                    LangId,
                    ...(TranslationIds && { TranslationIds }),
                    ...(SearchText && { SearchText })
                }
            }),
            providesTags: ['Translation'],
        }),
    }),
});

export const {
    useGetTranslationDataQuery,
} = translationApi; 